import React from 'react'

const Activities = () =>
{
    return (
        <>
            <div className="inner-head bg-animate">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-md-8 col-md-offset-2">
                            <h3>Activités</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div className="clearfix"></div>

            <section id="features" className="gray">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 xcol-md-offset-1 title-section">
                            <h5>L’association repose sur les principes de mutualités et de libre association.
                                Elle entend regrouper tous les anciens IAI de nationalité congolaise ayant adhérés quel
                                que soit leur lieu de résidence. Elle joue un rôle prépondérant à promouvoir les nouvelles
                                technologies de l’information de la communication dans le développement du Congo.
                                <br/>
                                <br/>
                                A cette fin, l'association compte les activités suivantes : </h5>
                            <div className="line"><i className="icon icon-24 icon-trophy"></i></div>
                        </div>
                    </div>
                    <div className="row wrap-feature-two">
                        <div className="col-md-4">
                            <ul className="feature-two left">
                                <li>
                                    <i className="icon icon-64 icon-tablet"></i>

                                    <h5>Formations</h5>
                                    <p>
                                        Réaliser des formations certifiantes dans le domaine des TIC sur l’entendue
                                        nationale et internationale
                                    </p>
                                </li>


                                <li>
                                    <i className="icon icon-64 icon-clipboard"></i>
                                    <h5>Applicatifs</h5>
                                    <p>
                                        Concevoir et développer des applicatives aux besoins des usagers
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <img src="assets/images/features/man.png" className="img-responsive img-feature-two" alt=""/>
                        </div>
                        <div className="col-md-4">
                            <ul className="feature-two right">
                                <li>
                                    <i className="icon icon-64 icon-rocket"></i>
                                    <h5>Promotion des TIC</h5>
                                    <p>
                                        Promouvoir des TIC sur tout l’étendue du pays
                                    </p>
                                </li>
                                <li>
                                    <i className="icon icon-64 icon-gamecontroller"></i>
                                    <h5>Promotion des talents</h5>
                                    <p>
                                        Promouvoir des talents et des activités de l’association
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>


            <div className="inner-page">
                <div className="container">
                    <div className="row">
                        <h5>Elle compte également : </h5>
                        <ul>
                            <li>
                                Rendre disponible le référentiel relatif aux compétences des anciens IAI
                                congolais ayant adhérés;
                            </li>
                            <li>Redynamiser les relations d’entraide entre les membres;</li>
                            <li>Veiller au développement intégral des membres ainsi que de leurs proches;</li>
                            <li>S'investir et promouvoir les activités professionnelles ou initiatives privées d’un membre;</li>
                            <li>
                                Contribuer au développement humain des membres ainsi que de leur milieu immédiat
                                par la production économique, morale et intellectuelle ainsi que par le développement
                                des mentalités, l’éveil des consciences;
                            </li>
                        </ul></div>
                </div>
            </div>
        </>
    );
}

export default Activities;